module.exports = __webpack_public_path__ + "static/media/infoJumbo3.6c39603f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/supplier/aalbers/images/infoJumbo3.jpg
// module id = 569
// module chunks = 0